module.exports = __webpack_public_path__ + "static/media/img106.348daa2f.jpg";